export enum ModelsTableColumnId {
  MODEL_ID = 'id',
  MODEL_NAME = 'name',
  ORGANIZATION = 'organization',
  ASSET_CLASS = 'asset_class',
  AVERAGE_RATING = 'average_sp_rating',
  AVERAGE_COUPON = 'average_coupon',
  AVERAGE_YTM = 'average_ytm',
  AVERAGE_YTW = 'average_ytw',
  AVERAGE_DURATION = 'average_duration',
  AVERAGE_MATURITY = 'average_maturity',
  AVERAGE_TAX_EQUIVALENT_YTW = 'average_tax_equivalent_ytw',
}

export const assumedInvestmentAmount = 1_000_000

export enum RatingMode {
  Investment = 'investment',
  HighYield = 'highYield',
  Custom = 'custom',
  None = 'none',
}
